import { createElement } from "@wordpress/element";

const Section = _ref => {
  let {
    description,
    title,
    children
  } = _ref;
  return createElement("fieldset", {
    className: "interface-preferences-modal__section"
  }, createElement("legend", {
    className: "interface-preferences-modal__section-legend"
  }, createElement("h2", {
    className: "interface-preferences-modal__section-title"
  }, title), description && createElement("p", {
    className: "interface-preferences-modal__section-description"
  }, description)), children);
};

export default Section;
//# sourceMappingURL=index.js.map